import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as StoreProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from '~/store';
import App from './App';

// On manual tab refresh (Ctrl+R / browser refresh), force opening '/overview'
if (typeof window !== 'undefined') {
  try {
    const navEntries =
      performance.getEntriesByType &&
      performance.getEntriesByType('navigation');
    const navEntry = navEntries && navEntries[0];
    const isReload = navEntry
      ? navEntry.type === 'reload'
      : performance.navigation && performance.navigation.type === 1;
    const allowedOnReload = ['/overview'];
    const path = window.location.pathname || '';
    const isAllowed =
      allowedOnReload.includes(path) || path.startsWith('/login');
    if (isReload && !isAllowed) {
      window.location.replace('/overview');
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
}

ReactDOM.render(
  <BrowserRouter
    future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
  >
    <StoreProvider store={store}>
      <App />
    </StoreProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);
